import { useEffect } from "react";

export const useTelegramWebApp = () => {
  useEffect(() => {
    const webApp = window.Telegram.WebApp;
    const platform = webApp.platform;

    if (platform === "android" || platform === "ios") {
      if (!webApp.isFullscreen) {
        webApp.exitFullscreen();
      }
      webApp.disableVerticalSwipes();
    }

    webApp.expand();

    if (platform === "android" || platform === "ios") {
      webApp.enableClosingConfirmation();
    }

    return () => {
      if (platform === "android" || platform === "ios") {
        webApp.disableClosingConfirmation();
      }
    };
  }, []);
};
